"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _immutable = require("immutable");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _reactTransitionGroup = require("react-transition-group");

var _classnames = _interopRequireDefault(require("classnames"));

var FormActions = _interopRequireWildcard(require("MeetingsLib/redux/actions/FormActions"));

var _UIFlex = _interopRequireDefault(require("UIComponents/layout/UIFlex"));

var _UIBox = _interopRequireDefault(require("UIComponents/layout/UIBox"));

var _UICardWrapper = _interopRequireDefault(require("UIComponents/card/UICardWrapper"));

var _UICardSection = _interopRequireDefault(require("UIComponents/card/UICardSection"));

var _EmailForm = _interopRequireDefault(require("MeetingsLib/components/sections/EmailForm"));

var _DatePickerSection = _interopRequireDefault(require("MeetingsLib/components/sections/DatePickerSection"));

var _FreemiumBookingUpgradeLink = _interopRequireDefault(require("MeetingsLib/components/freemium/FreemiumBookingUpgradeLink"));

var _TimeOptionsSection = _interopRequireDefault(require("MeetingsLib/components/sections/TimeOptionsSection"));

var _PropertyForm = _interopRequireDefault(require("MeetingsLib/components/sections/PropertyForm"));

var _LegalConsentForm = _interopRequireDefault(require("MeetingsLib/components/sections/LegalConsentForm"));

var _UserProfile = _interopRequireDefault(require("MeetingsBase/models/UserProfile"));

var _Branding = _interopRequireDefault(require("MeetingsBase/models/Branding"));

var _BookingLifecycle = _interopRequireDefault(require("MeetingsLib/models/BookingLifecycle"));

var _FormState = _interopRequireDefault(require("MeetingsLib/models/FormState"));

var FullSizeBookingPage = (0, _createReactClass.default)({
  displayName: "FullSizeBookingPage",
  propTypes: {
    avatar: _propTypes.default.string,
    branding: _propTypes.default.instanceOf(_Branding.default).isRequired,
    canSubmitInitialPropertyForm: _propTypes.default.bool,
    canTroubleshoot: _propTypes.default.bool,
    embedded: _propTypes.default.bool.isRequired,
    headline: _propTypes.default.string,
    isFetchingPublicAvailability: _propTypes.default.bool.isRequired,
    isSalesStarter: _propTypes.default.bool,
    markShowedEmailForm: _propTypes.default.func.isRequired,
    profile: _propTypes.default.instanceOf(_UserProfile.default).isRequired,
    shouldShowEmailForm: _propTypes.default.bool,
    bookingLifecycle: _propTypes.default.instanceOf(_BookingLifecycle.default).isRequired,
    formState: _propTypes.default.instanceOf(_FormState.default),
    legalConsentEnabled: _propTypes.default.bool.isRequired,
    legalConsentResponses: _propTypes.default.instanceOf(_immutable.List),
    resetEventDateTime: _propTypes.default.func.isRequired,
    resetFormState: _propTypes.default.func.isRequired,
    submittingMeeting: _propTypes.default.bool,
    DatePickerMarker: _propTypes.default.func.isRequired,
    TimePickerMarker: _propTypes.default.func.isRequired,
    EmailFormMarker: _propTypes.default.func.isRequired
  },
  getClassNames: function getClassNames() {
    var _this$props = this.props,
        isSalesStarter = _this$props.isSalesStarter,
        canTroubleshoot = _this$props.canTroubleshoot,
        embedded = _this$props.embedded;
    return (0, _classnames.default)('fullsize-container m-x-auto p-top-4', {
      'p-top-12': !isSalesStarter && !canTroubleshoot && !embedded
    });
  },
  getLegalBackFunction: function getLegalBackFunction() {
    var _this$props2 = this.props,
        canSubmitInitialPropertyForm = _this$props2.canSubmitInitialPropertyForm,
        resetEventDateTime = _this$props2.resetEventDateTime,
        resetFormState = _this$props2.resetFormState;
    return canSubmitInitialPropertyForm ? resetEventDateTime : resetFormState;
  },
  renderEmailForm: function renderEmailForm() {
    var _this$props3 = this.props,
        branding = _this$props3.branding,
        markShowedEmailForm = _this$props3.markShowedEmailForm,
        EmailFormMarker = _this$props3.EmailFormMarker;
    return _react.default.createElement(_EmailForm.default, {
      branding: branding,
      compact: false,
      goToNextStep: function goToNextStep() {},
      markShowedEmailForm: markShowedEmailForm,
      EmailFormMarker: EmailFormMarker
    });
  },
  renderDateTimeStep: function renderDateTimeStep() {
    var _this$props4 = this.props,
        avatar = _this$props4.avatar,
        headline = _this$props4.headline,
        embedded = _this$props4.embedded,
        branding = _this$props4.branding,
        profile = _this$props4.profile,
        isFetchingPublicAvailability = _this$props4.isFetchingPublicAvailability,
        isSalesStarter = _this$props4.isSalesStarter,
        DatePickerMarker = _this$props4.DatePickerMarker,
        TimePickerMarker = _this$props4.TimePickerMarker;
    var dateContainerStyle = null;

    if (embedded && !isSalesStarter) {
      dateContainerStyle = {
        maxHeight: '613px'
      };
    }

    return _react.default.createElement(_UICardWrapper.default, {
      key: "full-datetime",
      className: "p-all-0 height-100"
    }, _react.default.createElement(_UICardSection.default, {
      className: "p-all-0 height-100"
    }, _react.default.createElement(_UIFlex.default, {
      className: "height-100",
      direction: "column",
      align: "stretch"
    }, _react.default.createElement(_UIFlex.default, {
      direction: "row",
      className: "height-100",
      align: "stretch",
      style: dateContainerStyle
    }, _react.default.createElement(_UIBox.default, {
      basis: "50%",
      className: "height-100"
    }, _react.default.createElement(_DatePickerSection.default, {
      compact: false,
      avatar: avatar,
      branding: branding,
      embedded: embedded,
      headline: headline,
      profile: profile,
      DatePickerMarker: DatePickerMarker,
      TimePickerMarker: TimePickerMarker
    })), _react.default.createElement(_UIBox.default, {
      basis: "50%"
    }, _react.default.createElement(_TimeOptionsSection.default, {
      compact: false,
      branding: branding,
      profile: profile,
      isFetchingPublicAvailability: isFetchingPublicAvailability,
      TimePickerMarker: TimePickerMarker
    }))), !isSalesStarter && _react.default.createElement(_UIBox.default, null, _react.default.createElement(_FreemiumBookingUpgradeLink.default, {
      embedded: embedded
    })))));
  },
  renderPropertyForm: function renderPropertyForm() {
    var _this$props5 = this.props,
        branding = _this$props5.branding,
        canSubmitInitialPropertyForm = _this$props5.canSubmitInitialPropertyForm,
        submittingMeeting = _this$props5.submittingMeeting,
        bookingLifecycle = _this$props5.bookingLifecycle,
        resetEventDateTime = _this$props5.resetEventDateTime;
    return _react.default.createElement(_PropertyForm.default, {
      key: "full-property",
      branding: branding,
      canSubmitInitialPropertyForm: canSubmitInitialPropertyForm,
      goToPreviousStep: resetEventDateTime,
      dateTime: bookingLifecycle.event.dateTime,
      submittingMeeting: submittingMeeting
    });
  },
  renderLegalConsentFormSection: function renderLegalConsentFormSection() {
    var _this$props6 = this.props,
        branding = _this$props6.branding,
        submittingMeeting = _this$props6.submittingMeeting,
        bookingLifecycle = _this$props6.bookingLifecycle;
    return _react.default.createElement(_LegalConsentForm.default, {
      key: "full-legalConsent",
      branding: branding,
      goToPreviousStep: this.getLegalBackFunction(),
      submittingMeeting: submittingMeeting,
      dateTime: bookingLifecycle.event.dateTime
    });
  },
  renderStep: function renderStep() {
    var _this$props7 = this.props,
        shouldShowEmailForm = _this$props7.shouldShowEmailForm,
        bookingLifecycle = _this$props7.bookingLifecycle,
        formState = _this$props7.formState,
        legalConsentEnabled = _this$props7.legalConsentEnabled,
        legalConsentResponses = _this$props7.legalConsentResponses,
        submittingMeeting = _this$props7.submittingMeeting;

    if (shouldShowEmailForm) {
      return this.renderEmailForm();
    }

    if (!bookingLifecycle.event.dateString || !bookingLifecycle.event.dateTime) {
      return this.renderDateTimeStep();
    }

    if (!formState) {
      return this.renderPropertyForm();
    }

    if (legalConsentEnabled && !legalConsentResponses) {
      return this.renderLegalConsentFormSection();
    }

    if (submittingMeeting) {
      return this.renderLastStep();
    }

    return null;
  },
  renderLastStep: function renderLastStep() {
    var legalConsentEnabled = this.props.legalConsentEnabled;

    if (legalConsentEnabled) {
      return this.renderLegalConsentFormSection();
    }

    return this.renderPropertyForm();
  },
  render: function render() {
    return _react.default.createElement("div", {
      className: this.getClassNames()
    }, _react.default.createElement(_reactTransitionGroup.CSSTransitionGroup, {
      transitionName: "step-animation",
      transitionEnterTimeout: 500,
      transitionLeave: false
    }, this.renderStep()));
  }
});

var _default = (0, _reactRedux.connect)(function (state) {
  return {
    isSalesStarter: state.isSalesStarter
  };
}, FormActions)(FullSizeBookingPage);

exports.default = _default;
module.exports = exports.default;